<p-toast styleClass="custom-toast" closable="false" position="bottom-right" [baseZIndex]="5000">
  <ng-template let-message pTemplate="message" #participantOffersInvolvingProcessTmp>
    <div
      *ngIf="
        message.data.typeEnum !== toastEnum.archiveToast &&
        message.data.typeEnum !== toastEnum.involvingProcessAndPowerAttorneyToast &&
        message.data.typeEnum !== toastEnum.cloudLogisticEvent
      "
      class="toast-text"
      (click)="onReject($event)"
    >
      <span
        class="p-toast-message-icon pi"
        [ngClass]="{
          'pi-check': message.data.typeEnum === toastEnum.successToast,
          'pi-info-circle': message.data.typeEnum === toastEnum.infoToast,
          'pi-exclamation-triangle': message.data.typeEnum === toastEnum.warnToast,
          'pi-times-circle': message.data.typeEnum === toastEnum.errorToast
        }"
      ></span>
      <span class="toast-title" style="display: contents">
        {{ message.summary }}{{ message.data.requestEntityInfo }}{{ message.detail }}
      </span>
    </div>
    <div
      *ngIf="message.data.typeEnum === toastEnum.archiveToast"
      style="padding: 15px; width: 422px"
    >
      <div style="text-align: left">
        <span class="toast-title">
          {{ message.summary }}{{ message.data.requestEntityInfo }}{{ message.detail }}
        </span>
      </div>
      <div class="button-container">
        <button
          id="toastDownload"
          type="button"
          class="toast-button toast-button--download"
          (click)="onConfirm(message, $event)"
        >
          Скачать файл
        </button>
        <button
          id="toastClose"
          type="button"
          class="toast-button toast-button--close"
          (click)="onReject($event)"
        >
          Закрыть
        </button>
      </div>
    </div>
    <div
      *ngIf="message.data.typeEnum === toastEnum.involvingProcessAndPowerAttorneyToast"
      class="toast-text involving-process-toast"
      (click)="message.data.onClick(); onReject($event)"
    >
      <span class="p-toast-message-icon pi pi-info-circle"></span>
      <span class="toast-title">
        {{ message.detail }}
      </span>
      <span class="close-button" (click)="message.data.onClose($event)"></span>
    </div>
    <div
      *ngIf="message.data.typeEnum === toastEnum.cloudLogisticEvent"
      class="toast-text involving-process-toast"
    >
      <span [innerHTML]="message.detail" class="toast-title"> </span>
      <span class="close-button" (click)="message.data.onClose($event)"></span>
    </div>
  </ng-template>
</p-toast>
